import {
  Download,
  Refresh,
  ViewColumn,
  // CalendarMonth,
  // Close,
  Savings,
} from '@mui/icons-material'
import { GridToolbarContainer, useGridApiContext } from '@mui/x-data-grid-pro'
import {
  Tooltip,
  IconButton,
  Box,
  Checkbox,
  Menu,
  MenuItem,
  FormControlLabel,
  Typography,
  Button,
  CircularProgress,
  // Dialog,
  // Paper,
  // DialogTitle,
} from '@mui/material'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import LaunchIcon from '@mui/icons-material/Launch'
import {STELLAIR_FSE} from '../../../../helpers/env';
import { ToolbarInput } from '../../../../utils/ToolbarInput'
import { canViewPatientData } from '../../../auth/selectors/authSelector'

export type ToolbarProps = {
  title: string
  icon: string
  onRefresh: () => void
  onAdd?: () => void
  onDelete?: () => void
  searchText: string
  setSearchText: React.Dispatch<React.SetStateAction<string>>
  onExportCsv?: () => void
  isExportingCsv?: boolean
}

export function Toolbar({
  title,
  onRefresh,
  searchText,
  setSearchText,
  onExportCsv,
  isExportingCsv,
}: ToolbarProps) {
  const apiRef = useGridApiContext()
  const canViewPatientInfos = useSelector(canViewPatientData)

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  // const [openCalendar, setOpenCalendar] = useState(false)
  const open = Boolean(anchorEl)
  const columns = apiRef.current.getAllColumns()

  // const handleOpenCalendar = () => {
  //   setOpenCalendar(true)
  // }
  // const handleCloseCalendar = () => {
  //   setOpenCalendar(false)
  // }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleHide = (event: React.MouseEvent<any>) => {
    const column = columns.find(
      (column) => column.field === event.currentTarget.id,
    )
    if (column) apiRef.current.setColumnVisibility(column.field, !!column.hide)
  }

  return (
    <>
      <GridToolbarContainer
        sx={{
          background: 'linear-gradient(60deg, #84c2ce, #96dcea)',
          borderRadius: '0px 15px 0px 0px',
        }}
      >
        <Box
          ml={2}
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
          sx={{ pr: 10 }}
        >
          <Savings
            sx={{
              marginRight: '1rem',
              padding: '0px 10px 0px 0px',
              color: 'white',
              width: '10% ',
              height: '10%',
            }}
          />

          <Typography
            variant="h5"
            color="primary"
            sx={{ fontWeight: 'bold', color: 'white' }}
          >
            {title}
          </Typography>
        </Box>

        <Box sx={{ flexGrow: 1 }} />
        {/* <GridToolbarDensitySelector /> */}
        {/* <GridToolbarExport /> */}
        {/* <GridToolbarFilterButton /> */}
        {/* <Tooltip title={'Calendrier de facturation'}>
          <IconButton onClick={handleOpenCalendar}>
            <CalendarMonth />
          </IconButton>
        </Tooltip> */}
        <a href={STELLAIR_FSE} target="_blank" rel="noreferrer">
          <Button
            size="small"
            color="primary"
            aria-label="info"
            variant="contained"
            sx={{ marginRight: '1rem', background: '#ffa726' }}
          >
            <LaunchIcon />
            <Typography
              variant="body1"
              sx={{ fontWeight: 'bold', marginLeft: 1 }}
            >
              Stellair
            </Typography>
          </Button>
        </a>

        {/* Affiché uniquement quand BillingComponent fournit le handler :
            onglet A FACTURER et rôle autorisé à voir les données patient. */}
        {onExportCsv && (
          <Button
            onClick={onExportCsv}
            disabled={isExportingCsv}
            size="small"
            color="primary"
            aria-label="info"
            variant="contained"
            sx={{ marginRight: '1rem', background: '#ffa726' }}
          >
            {isExportingCsv ? (
              <CircularProgress size={'1rem'} sx={{ color: 'white' }} />
            ) : (
              <Download />
            )}
            <Typography
              variant="body1"
              sx={{ fontWeight: 'bold', marginLeft: 1 }}
            >
              Export CSV
            </Typography>
          </Button>
        )}

        <ToolbarInput
          searchText={searchText}
          setSearchText={setSearchText}
          label={
            !canViewPatientInfos ? 'ID patient' : 'ID patient, Nom/Prénom'
          }
        />

        <Tooltip title={'Colonnes'}>
          <IconButton
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
          >
            <ViewColumn />
          </IconButton>
        </Tooltip>

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          {columns.map((column, key) => (
            <MenuItem key={key} onClick={handleHide} id={column.field}>
              <FormControlLabel
                control={<Checkbox checked={!column.hide} />}
                label={column.headerName as string}
              />
            </MenuItem>
          ))}
        </Menu>

        <Tooltip title={'Rafraîchir'}>
          <IconButton onClick={onRefresh}>
            <Refresh />
          </IconButton>
        </Tooltip>
      </GridToolbarContainer>

      {/* <Dialog open={openCalendar}>
        <Paper elevation={2}>
          <DialogTitle
            id="responsive-dialog-title"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              background: 'linear-gradient(60deg, #84c2ce, #96dcea)',
              color: 'white',
              fontWeight: '700',
              fontSize: '24px',
            }}
          >
            {'Calendrier de facturation'}
            <IconButton onClick={handleCloseCalendar}>
              <Close sx={{ color: 'white' }} />
            </IconButton>
          </DialogTitle>
        </Paper>
        <Box></Box>
      </Dialog> */}
    </>
  )
}
